import React from "react";
import styles from "./styles.module.scss";

export interface IBadgeProps {
    text: string;
    variant?: "blue" | "green" | "red" | "purple" | "yellow" | "default";
    className?: string;
}

const Badge = ({ text, variant = "default", className = "" }: IBadgeProps) => {
    return (
        <div
            className={`${styles["badge"]} ${
                styles[`${variant}`]
            } ${className}`}
        >
            {text}
        </div>
    );
};

export default Badge;
